import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import HttpStatus from "./../helpers/status.enum";

import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { checkInActions } from "./../store/checkin.slice";
import { logActivity } from "./../helpers/activity-logger";
import 'react-toastify/dist/ReactToastify.css';
import Termsofserevice from "./termsofserevice";
import Privacypolicy from "./privacypolicy";
import Moment from "moment";
import SpinnerLoader from "../components/SpinnerLoader";
import { commonActions } from "./../store/common.slice";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Skeleton
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

function Checkedin({ checkedInPageHandle, checkingPageHandle, reservationPageHandle }) {
    // const [phone, setPhone] = useState('');
    const [records, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [cmsContent, setCmsContent] = useState(null);
    // T&C & Privacy Modal
    const [showtermsModal, setshowtermsModal] = useState(false);
    const [showprivacyModal, setprivacyModal] = useState(false);
    const [embeddedVideoURL, setEmbeddedVideoURL] = useState(null);
    const [validVideoURL, setValidVideoURL] = useState(false);

    const dispatch = useDispatch();

    const bookingSlug = useSelector(data => {
        return data.checkIn.value;
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await dispatch(checkInActions.getBookingByCode(bookingSlug));
                setData(result?.payload?.result);
                if (result?.payload?.result?.isCheckinCompleted === true) {
                    reservationPageHandle(true);
                    checkingPageHandle(false);
                    checkedInPageHandle(false);
                    // navigate("/reservationinfo");
                } else if (result?.payload?.result?.is_continue_accepted === 1) {
                    checkingPageHandle(true);
                    checkedInPageHandle(false);
                    // navigate("/checkingin");
                } else {
                    checkedInPageHandle(true);
                    // navigate("/checkedin");
                }
                const {video} = result?.payload?.result?.listing || {};
                if(video){
                    const iframeIncludes = video.includes("<iframe");
                    if(iframeIncludes) {
                        setValidVideoURL(true); // iframe can render the video
                    } else {
                        const url = getEmbedUrl(video);
                        if(url) { // if getEmbedUrl function returns truthy value
                            setValidVideoURL(true); 
                            setEmbeddedVideoURL(url);
                        }
                    }
                }

                logActivity("show_welcome_video", {
                    video_url: video ? video : '-',
                });

                const cmsResult = await dispatch(commonActions.getCmsContents());
                setCmsContent(cmsResult?.payload?.result);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        // Call the fetchData function inside useEffect
        fetchData();
    }, []);

    // Scroll to top when component mounts or navigates
    useEffect(() => {
        // Find the position of the "Checking In" section relative to the top of the document
        const checkingInSection = document.getElementById('checkedInpage');
        const sectionPosition = checkingInSection?.getBoundingClientRect().top;

        // Scroll the page to the position of the "Checking In" section
        window.scrollTo({
            // top: sectionPosition,
            behavior: 'smooth'
        });
    }, []);

    const handletermsModalOpen = () => {
        logActivity("terms_of_service_clicked");
        setshowtermsModal(true);
    };

    const handleprivacyModalOpen = () => {
        logActivity("privacy_policy_clicked");
        setprivacyModal(true);
    };

    const handleTapOnContinue = async (event) => {
        event.preventDefault(); // Correct method name
        try{
            setIsLoading(true);
            const result = await dispatch(checkInActions.markContinueAccepted(bookingSlug));
            if (result?.payload?.status === HttpStatus.HTTP_OK) {
                checkingPageHandle(true);
                checkedInPageHandle(false);
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }
    const getEmbedUrl = (videoUrl) => { // Function to convert video URL to embed URL 
        try {
            const url = new URL(videoUrl); // throw error if invalid url
            if (url.pathname.startsWith("/embed/")) { // Check if the URL is already an embed link 
                return videoUrl; 
            }
            if (url.hostname.includes("youtube.com") && url.pathname === "/watch") { // Handle YouTube watch links
                const videoId = url.searchParams.get("v");
                return `https://www.youtube.com/embed/${videoId}`;
            }
            return videoUrl; 
        } catch (error) {
            return null; // in-case if invalid URL
        }
    };

    const handleVideoFigureRef = (node) => {

  if (!node) return; // unmount

  // Find any iframe inside
  const iframes = node.querySelectorAll('iframe');

  iframes.forEach((iframe) => {
    if (iframe.dataset.checked) return;
    iframe.dataset.checked = 'true';

    const src = iframe.src;

    if (src.includes("vimeo.com")) {

    const match = src.match(/video\/(\d+)/);
    if (!match) return;

    const videoId = match[1];

    fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.height > data.width) {
          iframe.classList.add('vimeo-vertical-video');
        }
      })
      .catch(console.error);
    }

    if (src.includes("youtube.com") || src.includes("youtu.be")) {

        const height = parseInt(iframe.getAttribute("height"), 10);
        const width = parseInt(iframe.getAttribute("width"), 10);

        if (!height || !width) return;

        // Vertical (Shorts)
        if (height > width) {
            iframe.classList.add("youtube-vertical-video");
        } else {
            iframe.classList.add("youtube-horizontal-video");
        }
    }

    if (src.includes("instagram.com")) {
      iframe.classList.add('instagram-embed-video');
    }
  });
};
    
    return (
        <>
        {
            records && cmsContent && (
            <section className="checkedinpage" >
                <h3 id="checkedInpage">Welcome! Let's get you checked in!</h3>
                <div className="card-section">
                    <div className="cardYellow">
                    <figure>
                        {(records?.listing?.video && validVideoURL) ? (
                        records.listing.video.includes("<iframe") ? (
                            // Render the iframe HTML directly
                            <div
                            ref={handleVideoFigureRef}
                                dangerouslySetInnerHTML={{ __html: records.listing.video,}}
                            ></div>
                        ) : (
                            // Handle video URLs (if not an iframe)
                            <div ref={handleVideoFigureRef}>
                            <iframe
                                src={embeddedVideoURL}
                                allowFullScreen
                                title="Listing Video"
                            ></iframe>
                            </div>
                        )
                    ) : records?.listing?.image ? (
                        <img src={records.listing.image} alt="Listing Image" />
                    ) : (
                        <Skeleton duration={1} height={260} />
                    )}
                    </figure>
                        <div className="content">
                            <div className="checkedinDate">
                                <label>Check In</label>
                                <span className="dataLabel">{Moment(records?.checkin_datetime_format).format(global.dateTimeFormat)} </span>
                            </div>
                            <div className="checkedinDate">
                                <label>Check Out</label>
                                <span className="dataLabel"> {Moment(records?.checkout_datetime_format).format(global.dateTimeFormat)} </span>
                            </div>
                        </div>
                    </div>

                    <div className="cardOrange">
                        <div className="content">
                            <div className="checkedinDate">
                                <label>Why do I have to check in online?</label>
                                {/* <span className="dataLabel">{records?.first_name} {records?.last_name}</span> */}
                            </div>

                            <hr />

                            <Form onSubmit={handleTapOnContinue}>
                                <Form.Group
                                    className="mb-3"
                                >
                                    <Form.Label>
                                        <span
                                        className="guesty-description"
                                            dangerouslySetInnerHTML={{
                                            __html: `${records?.listing_alert?.checkin_description}`,
                                            }}
                                        ></span>
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group
                                    className="mb-3"
                                    >
                                    <Form.Label className="textfield-privacy">
                                        <span
                                            dangerouslySetInnerHTML={{
                                            __html: `${cmsContent?.checkedin_textarea}`,
                                            }}
                                        ></span>
                                    </Form.Label>
                                </Form.Group>
                                <div className="d-flex justify-content-center">
                                    <Button
                                        className="fillbutton"
                                        type="submit"
                                    >
                                        {isLoading ? (<><SpinnerLoader /></>) : ("Continue")}
                                    </Button>
                                </div>
                            </Form>
                            <p className="terms-privacy-policy-class">
                                By tapping Continue, I agree to the {" "}
                                <Link onClick={handletermsModalOpen} className="text-overline2">
                                    Terms of Service
                                </Link>{" "}
                                and{" "}
                                <Link onClick={handleprivacyModalOpen} className="text-overline2">
                                    Privacy Policy
                                </Link>
                                .
                            </p>
                        </div>
                    </div>
                </div>

                {/* T&C */}
                <Modal
                    show={showtermsModal}
                    onHide={() => setshowtermsModal(false)}
                    dialogClassName="modal-90w modal-bottom"
                    aria-labelledby="example-custom-modal-styling-title"
                    className="terms-privacy-policy"
                >
                    <Modal.Header
                        closeButton
                        onClick={() => setprivacyModal(false)}
                    ></Modal.Header>
                    <Modal.Body>
                        <Form>
                            <h2 className="mb-2">Terms of Service</h2>
                            <div className="moreContent">
                                <Termsofserevice data={cmsContent?.term_of_service} />
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                {/* T&C */}

                {/* Privacy */}
                <Modal
                    show={showprivacyModal}
                    onHide={() => setprivacyModal(false)}
                    dialogClassName="modal-90w modal-bottom"
                    aria-labelledby="example-custom-modal-styling-title"
                    className="terms-privacy-policy"
                >
                    <Modal.Header
                        closeButton
                        onClick={() => setprivacyModal(false)}
                    ></Modal.Header>
                    <Modal.Body>
                        <Form>
                            <h2 className="mb-2">Privacy Policy</h2>
                            <div className="moreContent">
                                <Privacypolicy data={cmsContent?.privacy_policy} />
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                {/* Privacy */}

            </section>
            )
        } 
        </>
    );
}

export default Checkedin;
